import { HTTP_METHODS } from 'src/utils/constants/HttpMethodsConstants';
import { TURN_OFF_VPN } from 'src/utils/constants/stringConstants';
import { getGuestUserToken } from 'src/utils/UtilityMethods';

import { getLocalStorage, getCookie } from '../../utils/browserStorageHandler';
import { getSpapiDdToken, getPlatformToken } from '../../utils/common';
import { XACCESS_AUTHORIZATION_COOKIE } from '../../utils/constants/cookieConstants';
import {
  GUEST_TOKEN,
  USER_TOKEN
} from '../../utils/constants/localStorageConstants';
import { httpService } from '../fetch/HttpService';

export const postForSinglePlay = async (url: string, obj: any) => {
  try {
    if (!getCookie(XACCESS_AUTHORIZATION_COOKIE)) {
      await getPlatformToken();
    }
    const userToken = getLocalStorage(USER_TOKEN);
    if (userToken) {
      obj.Authorization = `bearer ${userToken}`;
    } else {
      const guestToken =
        getLocalStorage(GUEST_TOKEN) || (await getGuestUserToken());
      obj['X-Z5-Guest-Token'] = guestToken;
    }
    obj['x-dd-token'] = getSpapiDdToken();

    return await httpService.fetchApiData({
      url,
      type: HTTP_METHODS.POST,
      body: obj,
      headers: []
    });
  } catch (error: any) {
    console.error('Something went wrong when fetching spapi response: ', error);
    if (error?.message?.includes(TURN_OFF_VPN)) {
      throw new Error(TURN_OFF_VPN);
    } else {
      throw error;
    }
  }
};
